import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

/** Renders nothing when announcement.enabled is false or text is empty. */
export default function AnnouncementBar() {
  const { data } = useQuery({
    queryKey: ["announcement"],
    queryFn: async () => (await api.get("/site-content/announcement")).data,
    staleTime: 60_000,
    retry: false,
  });
  if (!data || !data.enabled || !data.text?.trim()) return null;
  return (
    <div className="bg-gg-green text-white text-sm" data-testid="announcement-bar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-center">
        <span>{data.text}</span>
        {data.link_url && data.link_label && (
          <a href={data.link_url} className="underline hover:no-underline font-semibold">
            {data.link_label} →
          </a>
        )}
      </div>
    </div>
  );
}
